import React from "react";
import animation from "../assets/planted_tree_animation.mp4";
import { putPlantTree, callWithAuth } from "@/api/Api";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
} from "@chakra-ui/react";

interface PlantAnimationProps {
  isOpen: boolean;
  buttonAction?: () => void;
  onClose: () => void;
}

const PlantAnimation: React.FC<PlantAnimationProps> = ({ isOpen, buttonAction, onClose }) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const handleModalClose = () => {
    if (buttonAction) {
      buttonAction();
    }
    callWithAuth(putPlantTree)
      .then(() => {
        // Invalidate queries for reactquery
        queryClient.invalidateQueries({ queryKey: ["plantStats"] });
        queryClient.invalidateQueries({ queryKey: ["userStats"] });
        queryClient.invalidateQueries({ queryKey: ["waterDroplets"] });
      })
      .catch((error) => {
        // Handle error
        console.error("Error planting tree:", error);

        // Error toast
        toast({
          title: "Error planting tree",
          description: "Please try again later.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
      onClose();
  };

  return (
    <Modal isCentered isOpen={isOpen} onClose={handleModalClose} size={{base: "sm", lg: "lg"}}>
      <ModalOverlay backdropFilter="blur(10px)" />
      <ModalContent background={"#2b2b2b"}>
        <ModalCloseButton zIndex={20} />
        <div className="relative">
          <video
            autoPlay={true}
            muted={true}
            onEnded={handleModalClose}
            className="w-full h-auto rounded-md"
          >
            <source src={animation} type="video/mp4"></source>
          </video>
          <div className="absolute inset-0 flex items-start justify-center text-center font-semibold text-white text-lg pb-2">
            Way to go, you've planted a tree!
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default PlantAnimation;
